import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Loader } from '@mantine/core';
import { Breadcrumbs } from '@components';
import { DoubleCheckModal } from '@shared/ui';
import { ProductForm } from '@modules/products';
import { useEditProductForm } from '@modules/products/hooks/useEditProductForm';
import '@shared/styles/page.css';
import '../CreateProductPage/CreateProductPage.css';

export default function EditProductPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { productId } = useParams<{ productId: string }>();
  const productIdNum = productId ? parseInt(productId, 10) : 0;
  const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false);

  const backTo =
    (location.state as { from?: string } | null)?.from ??
    (productIdNum ? `/products/${productIdNum}` : '/products');

  const {
    product,
    productLoading,
    initialValues,
    handleSubmit,
    isSubmitting,
  } = useEditProductForm(productIdNum, {
    onSuccess: (result) => {
      navigate(backTo, {
        state: result?.wentToModeration
          ? { showModerationInfoOnLoad: true }
          : undefined,
        replace: true,
      });
    },
  });

  const confirmCancel = () => {
    setCancelConfirmOpen(false);
    navigate(backTo);
  };

  const title = product ? `Редактировать: ${product.name}` : 'Редактировать товар';

  return (
    <div className="page-container create-product-page">
      <Breadcrumbs
        items={[
          { label: 'Главная', path: '/' },
          { label: 'Товары', path: '/products' },
          ...(productIdNum
            ? [{ label: product?.name || 'Товар', path: `/products/${productIdNum}` }]
            : []),
          { label: 'Редактирование' },
        ]}
      />

      <div className="page-header create-product-page__header">
        <div className="create-product-page__title-row">
          <h1>{title}</h1>
          <button
            type="button"
            className="create-product-page__cancel"
            onClick={() => setCancelConfirmOpen(true)}
          >
            Отмена
          </button>
        </div>
      </div>

      <div className="content-wrapper create-product-page__content">
        {productLoading ? (
          <div className="empty-container">
            <Loader />
          </div>
        ) : product && initialValues ? (
          <ProductForm
            wizard
            isEdit
            onSubmit={handleSubmit}
            initialValues={initialValues}
            isLoading={isSubmitting}
          />
        ) : (
          <div className="empty-container">
            <p>Товар не найден</p>
          </div>
        )}
      </div>

      <DoubleCheckModal
        isOpen={cancelConfirmOpen}
        onClose={() => setCancelConfirmOpen(false)}
        title="Прекратить редактирование?"
        message="Точно ли вы хотите прекратить редактирование? Изменения не сохранятся."
        firstButtonText="Продолжить"
        secondButtonText="Прекратить"
        secondButtonAction={confirmCancel}
      />
    </div>
  );
}
